const primary = '#185a7d';

export default {
  primary,
}
